// extracted by mini-css-extract-plugin
module.exports = {"gist-resizer-row":"gist-frame_gist-resizer-row__eKaTc","gist-resizer":"gist-frame_gist-resizer__mlLQT"};